import Recipient from './recipient';

export default Recipient;
